import NavbarV2 from '../../components/navbarV2/NavbarV2';
import './BricomanV2.css';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const BricomanV2 = () => {
    const navigate = useNavigate();

    const order = (e) => {
        e.preventDefault();
        const name = document.getElementById("name").value;
        const email = document.getElementById("email").value;
        const order = document.getElementById("order").value;

        if (!name || name.length < 1) {
            toast.error('Please enter your name')
            return;
        }

        if (!email || email.length < 1) {
            toast.error('Please enter your email')
            return;
        }

        fetch(`${process.env.REACT_APP_API}/api/bricoman`, {
            method: 'POST',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json'
            },
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            body: JSON.stringify({
                name: name,
                email: email,
                order: order,
            })
        })
        .then(response => {
            if (response.status === 200) {
                toast.success('Ordered!')
                navigate('/')
            } else if (response.status === 500) {
                toast.error('Server error.')
            }
        });
    }

    return (
        <div className="v2-page bricomanv2">
            <NavbarV2 />

            <div className="v2-container v2-container--narrow">
                <h1 className="v2-h1">Bricoman</h1>
                <p className="v2-muted bricomanv2-lead">
                    Place a Bricoman order by listing SKUs and quantities. We will confirm by email.
                </p>

                <div className="v2-card">
                    <form
                        onSubmit={(e) => {
                            e.preventDefault();
                            order(e);
                        }}
                    >
                        <h2 className="v2-card-title">Your order</h2>

                        <div className="v2-field">
                            <label htmlFor="name">Name</label>
                            <input placeholder="John Doe" name="name" id="name" />
                        </div>

                        <div className="v2-field">
                            <label htmlFor="email">Email</label>
                            <input placeholder="johndoe@gmail.com" name="email" id="email" type="email" />
                        </div>

                        <div className="v2-field">
                            <label htmlFor="order">Order lines</label>
                            <textarea defaultValue="1x 10019641" name="order" id="order" />
                        </div>

                        <div className="v2-actions">
                            <button type="submit" className="v2-btn v2-btn--primary">
                                Submit order request
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default BricomanV2;